module.exports = __webpack_public_path__ + "zl8-de660622.png";